import { Counter } from '../../components/Counter';
import { SectionHeader } from '../../components/SectionHeader';
import { WeekCalendar } from '../../components/WeekCalendar';
import { CalendarSection, GuestLabel, GuestRow, Panel } from './ReservationPanel.styles';
import type { ReservationPanelProps } from './ReservationPanel.types';

export function ReservationPanel({
  title = 'Reservation.',
  subtitle = 'Pick a date and party size.',
  guestLabel = 'Guests',
  guestCount,
  minGuests = 1,
  maxGuests,
  onGuestCountChange,
  activeDate,
  selectedDate,
  availability,
  onDateSelect,
  onWeekNavigate,
  onCalendarClick,
  calendarLabels,
  counterDecreaseLabel,
  counterIncreaseLabel,
}: ReservationPanelProps) {
  return (
    <Panel>
      <SectionHeader title={title} subtitle={subtitle} />
      <GuestRow>
        <GuestLabel>{guestLabel}</GuestLabel>
        <Counter
          value={guestCount}
          min={minGuests}
          max={maxGuests}
          onChange={onGuestCountChange}
          decreaseLabel={counterDecreaseLabel}
          increaseLabel={counterIncreaseLabel}
        />
      </GuestRow>
      <CalendarSection>
        <WeekCalendar
          activeDate={activeDate}
          selectedDate={selectedDate}
          availability={availability}
          onDateSelect={onDateSelect}
          onNavigate={onWeekNavigate}
          onCalendarClick={onCalendarClick}
          labels={calendarLabels}
        />
      </CalendarSection>
    </Panel>
  );
}
